import React from "react";
import { BASE_TRACKER_URL } from "../../utils/constants";
import ArticleImage from "./ArticleImage";

interface NextArticleProps {
  image: string;
  title: string;
  isAvailable: boolean;
  onClick: () => void;
  nextTitle: string;
}

const NextArticle: React.FC<NextArticleProps> = ({
  image,
  title,
  isAvailable,
  onClick,
  nextTitle,
}) => {
  return (
    <div
      className="rounded bg-primary"
      style={{
        color: "var(--color-primary)",
        filter: isAvailable ? "none" : "grayscale(1) brightness(0.7)",
        opacity: isAvailable ? 1 : 0.6,
        pointerEvents: isAvailable ? "auto" : "none",
        cursor: isAvailable ? "pointer" : "default",
      }}
      onClick={onClick}
    >
      <ArticleImage image={image} title={title} height={50} />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          width: "100%",
          paddingRight: 16,
        }}
      >
        <span
          className="text-white"
          style={{
            padding: "0.1rem 0.2rem",
            fontSize: "0.85rem",
            borderBottomLeftRadius: "0.5rem",
            borderBottomRightRadius: "0.5rem",
            textAlign: "right",
          }}
        >
          {nextTitle}
        </span>
        <img
          src={`${BASE_TRACKER_URL}/arrow-right.svg`}
          alt="next article"
          style={{
            height: 18,
            marginLeft: 6,
            display: "inline-block",
            verticalAlign: "middle",
          }}
        />
      </div>
    </div>
  );
};

export default NextArticle;
